// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3259583117": "Powiadom klienta o przekierowaniu",
  "1d484fee4a": "Dział finansowy, Dział sprzedaży, Zarządzanie projektami, Dane biznesowe, Dział produktowy, Dział operacyjny, Zarządzanie badaniami i rozwojem, Planowanie wersji, Dział obsługi klienta, Dział administracyjny, Dział zakupów, Zarządzanie posprzedażowe",
  "a2c88dfb79": "Utwórz swój pierwszy zespół",
  "3cfdcc6086": "Dział finansowy, Dział sprzedaży, Zarządzanie projektami/305, Administracja personalna/306, Dział operacyjny, Zarządzanie badaniami i rozwojem, Planowanie wersji, Zarządzanie obsługą klienta/403, Dział zakupów, Zarządzanie posprzedażowe",
  "ac45ec2c05": "Niepowodzenie weryfikacji konta",
  "9aef9b8ccd": "Konto zalogowane jest nieprawidłowe, proszę zalogować się ponownie i spróbować",
  "728dd00f22": "Podany numer telefonu jest nieprawidłowy, spróbuj zalogować się za pomocą kodu SMS",
  "30dbecd916": "Twoje dane zawierają słowa kluczowe, które należy poprawić przed ponownym przesłaniem",
  "12ed508d8a": "Częstotliwość operacji jest zbyt wysoka, spróbuj ponownie później",
  "952d4a7595": "Nieprawidłowy stan logowania na koncie, proszę zalogować się ponownie i spróbować",
  "e64bfdeaa4": "Weryfikacja nie powiodła się, proszę uzyskać nowy kod SMS",
  "79008a65f1": "Numer telefonu jest powiązany z kilkoma firmami, zaloguj się do odpowiedniej firmy lub zmień numer telefonu",
  "bf242eff42": "Nazwa firmy już istnieje",
  "4f0cdb8374": "Wprowadź pełny numer telefonu. Jeśli korzystasz z numeru zagranicznego, użyj krajowego (86+)",
  "46e79ffeff": "Nieudana próba tworzenia firmy, skontaktuj się z oficjalną obsługą klienta",
  "f3e18f0341": "Weryfikacja parametrów nie powiodła się",
  "503fd1718d": "Nie udało się wysłać kodu SMS",
  "24b3129f19": "Wysłano zbyt wiele wiadomości, spróbuj ponownie później",
  "1cde3e8245": "Kod weryfikacyjny jest nieprawidłowy, wpisz ponownie",
  "4212ecc031": "Zostało popełnionych zbyt wiele błędów walidacyjnych, weryfikacja została tymczasowo zablokowana, spróbuj ponownie później",
  "735da9c347": "Problem z weryfikacją powiązaną z nazwą firmy, skontaktuj się z oficjalną obsługą klienta",
  "8731da9615": "Nieprawidłowa weryfikacja powiązana z nazwą firmy, skontaktuj się z oficjalną obsługą klienta",
  "62e89b3f16": "Zgadzam się z warunkami usługi",
  "c9b79027e5": "Wyślij kod weryfikacyjny",
  "84c1447b9d": "Skopiowano pomyślnie",
  "fba4b0abd0": "Zapis rekordu głównego",
  "37f5a7cd41": "Wartość TXT",
  "78b12427c9": "Trwa weryfikacja...",
  "59d089837c": "Obecnie nie możemy zweryfikować Twojej domeny. Być może będziesz musiał poczekać, aż usługa zarządzania domeną zaktualizuje Twoje informacje. Jeśli po pewnym czasie nadal nie będzie reakcji, spróbuj zweryfikować ponownie lub zmień domenę.",
  "4a5b7383d1": "Sprawdzanie rekordu weryfikacyjnego dla domeny",
  "f24a492e40": "Możesz zamknąć tę stronę i wrócić później, aby sprawdzić ponownie.",
  "c697ca5f1a": "Witamy w wersji Enterprise",
  "ebb01b1740": "Dalej",
  "30109bf753": "Czy Twoja firma posiada domenę?",
  "2b3e485b47": "Mam domenę firmową",
  "1a7f5eae44": "Nie mam domeny firmowej",
  "bde15d6d84": "Potrzebujesz domeny (na przykład example.com), aby utworzyć konto firmowe.",
  "07ffb22c90": "Przepraszamy, potrzebujesz domeny, aby utworzyć konto firmowe.",
  "de23836563": "Wprowadź domenę, aby utworzyć konto firmowe.",
  "287c07944a": "Zweryfikuj swoją domenę",
  "3ea2d528d5": "Ukończ poniższe kroki, aby udowodnić, że jesteś właścicielem <b>{domain}</b> i uniemożliwić innym użycie tej domeny do rejestracji konta firmowego.",
  "082b18ce56": "a. Otwórz stronę usługodawcy hostingu domen w <b>nowej karcie</b> i <b>zaloguj się</b> do swojego konta;",
  "4f7e0841a9": "b. Na stronie usługodawcy hostingu domen, przejdź do sekcji <b>rekordów DNS</b>. Nazwa sekcji rekordów DNS na stronie usługodawcy może się różnić, na przykład wyświetlana jako <b>DNS Management (Zarządzanie DNS), Name Sever Management (Zarządzanie Serwerami Nazw), Control Panel (Panel Kontrolny) lub Advanced Setting (Zaawansowane Ustawienia).</b>",
  "6365ad6e3a": "Następnie, <b>wróć tutaj</b>, a następnie kliknij „Dalej”, aby dodać rekord weryfikacyjny.",
  "8528892080": "Dodaj rekord weryfikacyjny",
  "7a225304f8": "a. Na stronie DNS, przewiń do sekcji <b>TXT</b>, a następnie kliknij odpowiedni przycisk, aby dodać rekord;",
  "b3cb7d947c": "b. Wszystkie poniższe wartości <b>skopiuj i wklej</b> w formularzu <b>TXT</b> na stronie usługodawcy hostingu domen.",
  "47213583bf": "c. <b>Zapisz</b> rekord na stronie dostawcy hostingu domen,<br>następnie <b>wróć tutaj</b> i kliknij „Weryfikuj domenę” poniżej.",
  "21486a57cf": "Uwaga: W polu Nazwa/Host/Alias możesz wpisać „@” lub pozostawić je puste. Dostawca hostingu domen może również wymagać wpisania nazwy domeny w tym polu (<twojadomena>.com). Możesz sprawdzić, jak wypełnić to pole, patrząc na inne rekordy DNS. W polu Czas przechowywania (TTL) wpisz „86400” lub zachowaj wartość domyślną.",
  "f1b8edab9c": "Zmień domenę",
  "7c6fc663a8": "Zatwierdź domenę",
  "b6aee9dc0d": "Weryfikacja domeny zakończona sukcesem",
  "dd4cc429ea": "Udowodniono, że jesteś",
  "450f5c9230": "właścicielem oraz uniemożliwiono rejestrację konta firmowego przez inne osoby.",
  "71cbcba755": "Kliknij „Dalej”, aby ukończyć zakładanie konta firmowego.",
  "f4084f4870": "Proszę ustawić swoje konto logowania",
  "fe3138baec": "Zakończ tworzenie",
  "0315cddedb": "Stworzenie firmy zakończone sukcesem",
  "91454a7f34": "Przejdź teraz do panelu administracyjnego i utwórz konta firmowe dla swoich członków firmy.",
  "366304cde7": "1. Nastąpi automatyczne wylogowanie z bieżącego konta WPS",
  "8a9f2a8422": "2. Musisz zalogować się do panelu administracyjnego za pomocą konta firmowego {account}@{domain}",
  "43e265e998": "Przejdź do panelu administracyjnego",
  "9240efaaf0": "SMS został wysłany",
  "e424bb9a6d": "Wprowadź",
  "d44d581706": "Nazwa firmy",
  "aa8679f406": "4-30 znaków",
  "581bdb1f98": "Nie może zawierać specjalnych znaków \\/:*?\"<>|{}",
  "c13cabb67a": "Adres e-mail:",
  "2b9b429e46": "Twój adres e-mail",
  "5ed834a7df": "Proszę wprowadzić swój adres e-mail",
  "acfd1f02ed": "Proszę wprowadzić poprawny adres e-mail",
  "31c7c92cca": ", maksymalnie 80 znaków",
  "3f27cf84b3": "Wprowadź kod weryfikacyjny",
  "a0ae1f3ec4": "Kod weryfikacyjny jest niepoprawny",
  "e5589c5e74": "Twoje imię",
  "69d7bd63f6": ", tylko znaki chińskie, litery, cyfry",
  "91f008d258": ", maksymalnie 8 znaków",
  "6ea6c9b39b": "Numer telefonu",
  "161042c5b7": "Proszę wprowadzić numer telefonu kontaktowego",
  "e6b8eab1cd": "Proszę wprowadzić numer telefonu kontaktowego, 11 cyfr",
  "3fd5fbb3cc": "Proszę wprowadzić swoją domenę",
  "cb5346ba8e": "Proszę wprowadzić poprawną nazwę domeny firmowej, od 4 do 30 znaków",
  "27928eb7a4": "Konto",
  "8e19bd444d": "Proszę wprowadzić nazwę konta do logowania",
  "7bbbf479dc": "4-20 znaków, tylko cyfry, litery lub podkreślniki",
  "3d84cae479": "Proszę wprowadzić konto spełniające wymagania, którego pierwszy znak musi być literą lub cyfrą",
  "c0d5ece1a7": "Hasło",
  "f444036fa8": "Wprowadź hasło",
  "b03218d72b": "Hasło musi składać się z 12-16 znaków, w tym dużych i małych liter, cyfr lub 3 różnych kombinacji",
  "b4ab05df50": "*W Twojej jednostce ktoś już używa Twojej domeny do konta firmowego, skontaktuj się z obsługą klienta (400-677-5005), aby potwierdzić, że posiadasz prawa własności do tej domeny",
  "c58876008f": "Kopiowanie nie powiodło się, spróbuj ponownie",
  "86f73420de": "Link zaproszenia",
  "a58861962c": "Przykro nam, Twoja przeglądarka nie obsługuje pobierania tego kodu QR",
  "228db07f78": "Dział Finansowy, Dział Sprzedaży, Zarządzanie Projektami, Dane Biznesowe, Dział Produktu, Dział Operacji, Zarządzanie Badaniami i Rozwojem, Plan Wersji, Dział Obsługi Klienta, Dział Administracyjny, Dział Zakupów, Zarządzanie Posprzedażowe",
  "93896d7e98": "Po utworzeniu zespołu, rozpocznij współpracę z kolegami",
  "e8f66fb75c": "Dział Finansowy, Dział Sprzedaży, Zarządzanie Projektami/305, Administracja Personalna/306, Dział Operacji, Zarządzanie Badaniami i Rozwojem, Plan Wersji, Zarządzanie Obsługą Klienta/403, Dział Zakupów, Zarządzanie Posprzedażowe",
  "831b73da9b": "Nazwa nie może zawierać nielegalnych znaków i symboli specjalnych /\\;:*?\"<>|%&",
  "51ab33b3ee": "Nieprawidłowy parametr",
  "a297f9e951": "Nazwa firmy jest zduplikowana",
  "04d60ed5f5": "Nie można używać zabronionych słów",
  "2ff7bef083": "Błędny format domeny",
  "41e1ba2165": "Nie powiodło się sprawdzenie informacji TXT domeny",
  "50f348caa9": "Konto się powiela",
  "9d4c950d65": "Ta nazwa została już zarejestrowana",
  "38cf19ed95": "Nazwa instytucji już istnieje",
  "4b426e7c9c": "Nazwa instytucji",
  "298f880e18": "Już istnieje, zalecamy dodanie więcej informacji:",
  "1e67dd20b3": "Odzyskaj nazwę instytucji",
  "517107cb04": "Użyj innej nazwy",
  "5667081882": "Utwórz używając tej nazwy",
  "e306a979a6": "Szybkie wprowadzenie:",
  "f583db96e0": "*Jeśli nazwa instytucji jest zajęta, możesz",
  "9767148e34": "Wpisz nazwę firmy lub organizacji, 2-120 znaków",
  "e0e0ec159f": "Nazwa instytucji",
  "5b13d254c0": "Ta nazwa firmy już istnieje",
  "92027671ec": "Nazwa firmy",
  "36d482a7fb": "Odzyskaj nazwę firmy",
  "79058a7577": "*Jeśli nazwa firmy jest zajęta, możesz",
  "c96dd48dba": "Nazwa firmy",
  "842efad336": "*Jeśli jesteś pracownikiem firmy, proszę",
  "860f9bd77b": "Obsługa klienta",
  "5a7ed18daf": "Dołącz do firmy",
  "ab470e9ace": "Pozostaw informacje kontaktowe",
  "0a7e0e48a7": "Nazwa firmy, do której aplikujesz:",
  "a8dc318dcc": "Sprawdź swoje dane kontaktowe, wkrótce skontaktuje się z Tobą obsługa klienta",
  "6ea1f4d7f5": "Prześlij dane",
  "d439e39f43": "Otrzymaliśmy Twoje dane",
  "884653426b": "Obsługa klienta zadzwoni do Ciebie w ciągu 24 godzin, proszę odbierz telefon!",
  "2361cb14bf": "Zeskanuj kod WeChat, aby dodać online obsługę klienta i sprawdzić postęp",
  "50f45d0031": "Zapisywanie nie powiodło się",
  "fc856d0fd2": "Superadministrator",
  "e16c0676d2": "Administratorzy",
  "b1d2ddd126": "Zwykły członek",
  "9d322cc08d": "Nazwa instytucji nie może zawierać symboli specjalnych \\ / : * ? \" <> | {}",
  "b583ba7363": "Nazwa firmy nie może zawierać symboli specjalnych \\ / : * ? \" <> | {}",
  "1d118a9bad": "Nazwa instytucji musi mieć co najmniej 2 znaki, wprowadź nazwę instytucji o długości od 2 do 120 znaków",
  "441b45b1f5": "Nazwa firmy musi mieć co najmniej 2 znaki, wprowadź nazwę firmy o długości od 2 do 120 znaków",
  "97457cb1f0": "Nazwa instytucji przekracza 120 znaków, wprowadź nazwę instytucji o długości od 2 do 120 znaków",
  "8ce00d3b92": "Nazwa firmy przekracza 120 znaków, wprowadź nazwę firmy o długości od 2 do 120 znaków",
  "a72778d3de": "Imię musi mieć co najmniej 2 znaki, wprowadź imię o długości od 2 do 10 znaków",
  "79c17db5de": "Imię przekracza 10 znaków, wprowadź imię o długości od 2 do 10 znaków",
  "482a118202": "Imię i nazwisko może zawierać tylko znaki chińskie, cyfry, angielskie litery oraz ·",
  "9a9be18941": "Proszę zaznaczyć",
  "e6b7c4aa66": "Umowa o świadczenie usług online",
  "595023d905": "Utwórz instytucję",
  "ba8c2df551": "Ukryj standardowe lokalizacje",
  "d284384975": "Umowa o Usługi Online",
  "5c266d5a84": "Zasady ochrony prywatności",
  "fcb92dbcf6": "Umowa o Usługi Chmury",
  "2ae7a8a3f7": "Dziękujemy za wybór WPS 365 Usług Chmury. Poniżej znajduje się opis prawnej umowy pomiędzy Tobą i/lub organizacją którą reprezentujesz a Kingsoft dotyczący rejestracji, subskrypcji oraz korzystania z tej usługi.",
  "d30a6983bd": "Przeczytaj {0} | {1} | {2}, kliknij „Zgadzam się”, a to będzie oznaczało wyrażenie zgody na treść tego porozumienia i akceptację naszych usług.",
  "263e306ede": "Przeczytałem i akceptuję {0} | {1} | {2}",
  "440129c0f1": "Proszę wprowadzić {0}",
  "8ab916983d": "Nazwa firmy",
  "b01d68543b": "Twoje imię",
  "684b30d4e9": "Twój numer telefonu",
  "a48427e8e2": "Przeznaczone do stworzenia platformy roboczej dla Twojej firmy",
  "3a81b0f1fc": "Ułatwia współpracownikom znalezienie Cię w systemie i współpracę",
  "52bc539b6e": "Potwierdź utworzenie",
  "b2fe245e19": "Utwórz Firmę/Zespół: Udostępnianie Plików i Współpraca",
  "893282d3f7": "Proszę uzupełnić informacje o firmie:",
  "cc997bf6aa": "Potwierdź",
  "50fdde51ac": "{0}, {1}~{2} znaków",
  "a19cc5ec18": "{0} nie może zawierać specjalnych znaków \\/:*?\"<>|{}",
  "26857f28f9": "{0}, tylko znaki chińskie, litery, cyfry",
  "f4080b1431": "{0}, maksymalnie {1} znaków",
  "88e59b2d58": "{0}, 11 cyfr",
  "91d6d4e105": "Proszę wprowadzić kod weryfikacyjny",
  "bec71bde96": "Kod weryfikacyjny jest niepoprawny",
  "e20ff8ee19": "{0} jest wymagane",
  "8dc09d10d7": "Nie znaleziono dwId",
  "a03766ce6c": "Szkoła",
  "03542addfe": "Przedsiębiorstwo",
  "adb8a815d1": "Limit powiązań dla numeru telefonu {0} został osiągnięty",
  "97a6b66f1d": "Aktualny numer telefonu jest już powiązany z {0}",
  "665e465487": "Nie można utworzyć {0}, bieżący numer telefonu „<strong>{1}</strong>” ma ograniczoną liczbę przypisanych {0} (maksymalnie można przypisać 5 {2}), możesz przejść do poniżej przypisanych {3}:",
  "a85b1367ca": "Aktualny numer telefonu „{0}” jest już powiązany z {1}, możesz wybrać istniejące {2} do zalogowania lub utworzyć nowe {3}:",
  "bf992ce17b": "Utwórz {0} przy użyciu innego numeru telefonu",
  "395ea04444": "Utwórz nowe {0}",
  "4ce3bb86b3": "Limit przystąpienia do {0} został osiągnięty",
  "df88c4b7a5": "Aktualny numer telefonu „{0}” osiągnął maksymalną liczbę powiązań {1}",
  "78f7dd59ca": "Aktualny numer telefonu „{0}” jest powiązany z poniższymi {1}, można bezpośrednio przełączyć się na użycie",
  "8db491a3f8": "Kontynuuj tworzenie nowego {0}",
  "83f6d9e1e4": "Spróbuj ponownie",
  "1dc5f11612": "lub",
  "217d76f53e": "Opinie",
  "b69a6ea62a": "Proszę przytrzymać lewy przycisk myszy, aby odkryć obie tarcze",
  "3a31f64800": "Gratulacje, udało się odkryć tarczę<br/>Kontynuuj do następnego kroku",
  "6a81fcee96": "Ładowanie",
  "e97877a65d": "Ojej, tarcza zniknęła<br/>Proszę",
  "8d85456145": "Czekałem zbyt długo<br/>Proszę",
  "77ad847b95": "Połączenie internetowe jest bardzo słabe<br/>Proszę",
  "dbd1ae3a34": "Zdrapujesz zbyt szybko<br/>Proszę",
  "bd8e05cd53": "Kliknij przycisk, aby rozpocząć inteligentną weryfikację",
  "63d2a8a722": "Weryfikacja zakończona sukcesem",
  "73141928ad": "Weryfikacja nie powiodła się, proszę kliknąć przycisk, aby odświeżyć",
  "04856c5c8a": "Inteligentna detekcja w toku",
  "52cd9bd26d": "Operacja nieautoryzowana",
  "fd157e8ea8": "Przewodnik po tworzeniu",
  "c6225c5b2b": "Witamy w wersji dla firm",
  "e33423fb1e": "Utworzono pomyślnie",
  "7b0c035999": "Strona sukcesu tworzenia firmy dla Kingsoft Docs",
  "85db8faae0": "Instrukcja użytkowania wersji dla firm",
  "20591b9b44": "Odzyskiwanie nazwy firmy",
  "b023d76dc2": "Przewodnik po przesyłaniu przez członka",
  "e2f454e095": "Firma {0}",
  "df466f942b": "Oddział",
  "26a7b797c4": "Centrum dystrybucji",
  "5fc82b360b": "Platforma do kompleksowej obsługi biurowej, która sprawi, że praca będzie bardziej efektywna",
  "f2e736d52e": "Witamy w wersji dla firm",
  "becc41a35b": "Nazwa firmy",
  "74685cdc58": "Proszę wprowadzić nazwę firmy lub organizacji, 2-120 znaków",
  "07b55b1907": "Rozmiar przedsiębiorstwa",
  "77b2f763ad": "Proszę wybrać rozmiar firmy",
  "49d2509109": "Mniej niż 5 osób",
  "8db2c9b74a": "6-20 osób",
  "a9fb0cf14a": "21-50 osób",
  "0fed41f8d3": "51-100 osób",
  "fb33f25a04": "101-200 osób",
  "3e3ff0f52e": "201-500 osób",
  "cd8b51f634": "501-2000 osób",
  "0662fa6eec": "Powyżej 2000 osób",
  "69334dba1a": "Potrzeby przedsiębiorstwa",
  "79994e749c": "(Zalecimy najlepsze rozwiązania branżowe dla przedsiębiorstwa)",
  "840a017f38": "Proszę wybrać najważniejszy problem do rozwiązania",
  "f045b05c73": "Wpisz swoje wymagania dotyczące założenia firmy",
  "d8efb0b36d": "Więcej",
  "adcb8fbb0c": "Często używany numer telefonu",
  "eb1c73e2ca": "Proszę wpisać swój często używany numer telefonu z 11 cyframi",
  "7f276e7dfa": "Utwórz za darmo",
  "c391b3eec1": "Nie udało się wysłać SMS-a",
  "54f4cb8fa7": "SMS został wysłany",
  "231eb1fa1e": "Użytkownik firmowy {0}",
  "272b0f9d32": "Użytkownik z przedsiębiorstwa",
  "b209a67331": "Nie udało się utworzyć przedsiębiorstwa, proszę odświeżyć stronę.",
  "acb08d0cc9": "Trzeci krok tworzenia przedsiębiorstwa",
  "83db361f51": "Po utworzeniu, uruchom logikę przekierowania",
  "1e930326e3": "handleStep przejście do następnego kroku",
  "184df5c725": "saveForm nie powiodło się",
  "736eab3023": "Prześlij walidację",
  "2db62dc13c": "Walidacja nie powiodła się",
  "54fb0afaea": "Walidacja zakończona sukcesem",
  "d39cff3fcf": "Pomijaj skrajne zapisywanie dopóki nie stwierdzono potrzeby kodu weryfikacyjnego",
  "305b777ae5": "Sprawdzenie nazwy nie powiodło się, wyświetl\"Okno dialogowe Zajęta nazwa firmowa\" i zachowaj nazwę",
  "e57b6686b2": "Sprawdź, czy główny podmiot jest już certyfikowany, uruchom okno informacyjne o ochronie certyfikatu i przechowaj odpowiednie informacje o certyfikacie",
  "f7c86f496d": "Utwórz pozycję zduplikowaną || Kod weryfikacyjny wygasł. Jeśli istnieje niezgodność, zatrzymaj wykonanie",
  "cb37db4fd4": "handleSubmit nie powiodło się",
  "243a569fc4": "Ta nazwa jest już zarejestrowana, proszę użyć innej nazwy",
  "196851a3d9": "Użytkownik firmowy {0}",
  "0c3a3595ff": "Użytkownik z przedsiębiorstwa",
  "a33b41e0f2": "Nie udało się utworzyć przedsiębiorstwa, proszę odświeżyć stronę.",
  "fcce6a7156": "Utworzono pomyślnie",
  "5ec6da58a6": "Powiadom klienta",
  "259c9dfa4e": "Logika wersji profesjonalnej",
  "864156930f": "Logika vba",
  "7824efd172": "Mobilna wersja AirPage",
  "52b6cfaaaf": "Klient WPS",
  "c7c51beea9": "Wersja edukacyjna",
  "8d054d4986": "Domyślna wersja",
  "b597e18fb1": "isWps365PcClient i dostępność openurl",
  "b0c13de2a0": "isWps365PcClient lub nie-client, dostępność openurl",
  "7d0f2ce18c": "isWps365PcClient lub nie-client, dostępność i sukces openurl callback",
  "e2c5a07df6": "Nie klient, nie openurl",
  "29e0414d1f": "Nie klient, nie openurl, callback",
  "60861f7d2a": "AutoChange, pozostaw decyzję biznesowi",
  "7c83140d90": "Tworzenie stanu gościa, nie wymaga zmiany konta przez SDK (SDK nie obsługuje gościa), kod już zmienił konto przez API",
  "3379b09e59": "Istnieje openurl i używa href do przełączania",
  "586ff04c22": "Osobno przejście",
  "b6c91f218b": "UseSuccessSkip nie powiodło się",
  "47d2f3ba66": "Więcej",
  "57551f86ce": "Różne metody przekierowywania na podstawie utm_source",
  "64fe3758e2": "Twoja operacja jest nieautoryzowana",
  "4da3e1262f": "Tworzenie zakończone sukcesem, rozpocznij podróż firmową",
  "c38dfb8c6c": "Stwórz swój pierwszy zespół",
  "38dddb483b": "Wejdź do firmy",
  "614d9c91eb": "Zaproś członków dołączyć",
  "97f1eca0aa": "Wejdź do firmy",
  "13a4939e90": "Dołącz do zaproszenia do firmy",
  "a319e4ae0a": "Zaproś współpracowników do dołączenia",
  "12e4da6bba": "Natychmiast zaproś współpracowników",
  "bd885380f6": "Nie udało się uzyskać linka do zaproszenia",
  "5e626c4063": "SMS został wysłany",
  "3dc09e7cfd": "Osiągnięto limit liczby nazw firm, które można odzyskać",
  "48318f41f9": "Zaproś członków dołączyć",
  "45441baac4": "Zapraszam cię do współpracy w {0}",
  "e5847fbd67": "Skopiuj link, zaproś członków",
  "23101dd40a": "Dostosowuję dla Ciebie rozwiązanie",
  "71bb7e54a8": "Zarządzanie projektem",
  "aff37c79cc": "Wypróbowanie wybranej opcji",
  "a97b174258": "Zaproś jeszcze <color: red>2</> współpracowników, aby bezpłatnie zyskać poniższe prawa firmowe",
  "253855849f": "Udostępnij link do zaproszenia w grupie roboczej, zaproś współpracowników",
  "57b0a2a63f": "Skopiuj link, zaproś współpracowników",
  "71c0a37ee1": "Wejdź do firmy",
  "f848c60e0e": "Zaproś jeszcze <color:red>2</> kolegów, aby otrzymać bezpłatne korzyści dla firm",
  "664e32b4fe": "Na stronie zaproszenia wejdź do firmy",
  "872f14403a": "Zaproś współpracowników do dołączenia",
  "1880e7deb9": "Natychmiast zaproś współpracowników",
  "cc2a9aaf82": "Tworzenie zakończone sukcesem",
  "02a13e2583": "Zaproś jeszcze <color: red>2</> współpracowników, aby bezpłatnie zyskać poniższe prawa firmowe",
  "5d3593cdce": "Nie udało się uzyskać informacji o zespole",
  "c025113ea1": "Nie udało się uzyskać linka do zaproszenia",
  "b83bc1e485": "Link zapraszający",
  "0996ced9f6": "Przepraszam, ale Twoja przeglądarka nie obsługuje pobierania tego kodu QR",
  "1e88451e31": "Link do zaproszenia skopiowany",
  "bb969cabcd": "Kopiowanie nie powiodło się, spróbuj ponownie",
  "15e1f79c7a": "Aplikuj o dołączenie do firmy",
  "59c22b4ef8": "Otrzymałeś link do zaproszenia",
  "0f0b392e60": "Utwórz swoją pierwszą drużynę",
  "0437d07c43": "Nazwa firmy",
  "41800c7bf1": "Proszę wprowadzić imię i nazwisko stworzyciela",
  "1ec5999511": "Imię i nazwisko stworzyciela może mieć maksymalnie 8 znaków",
  "02da35b4e4": "Imię i nazwisko stworzyciela może zawierać tylko znaki chińskie, litery i cyfry",
  "184e9f6616": "Proszę wprowadzić numer telefonu kontaktowego",
  "9b587898ba": "Proszę wprowadzić prawidłowy format numeru telefonu",
  "e68c164a02": "Proszę wprowadzić swój adres e-mail",
  "0b1de22df7": "Proszę wprowadzić prawidłowy format adresu e-mail",
  "61026181ab": "Wymagany jest numer licencji biznesowej",
  "c3847e604e": "Rozmiar pliku przekracza 10 MB, proszę wybrać ponownie",
  "49450f4ec7": "Wymagany jest formularz reklamacji o zapożyczenie nazwy",
  "39c3b8fa1d": "Nie udało się przesłać",
  "3ea44d7963": "Przesłano pomyślnie",
  "5b1aa3c2c4": "Przesyłanie nie powiodło się",
  "7e7f81eaa3": "Przesyłanie nie powiodło się, plik większy niż 10 MB",
  "2ff1913de1": "Przesyłanie nie powiodło się, plik musi być w formacie .jpg, .jpeg, .png, .bmp, .pdf",
  "7951a879f2": "Wymagany jest numer licencji biznesowej",
  "66bda65057": "Rozmiar pliku przekracza 10 MB, proszę wybrać ponownie",
  "8f2305a83d": "Wymagany jest formularz reklamacji o zapożyczenie nazwy",
  "55ff0c8c6e": "Nie udało się przesłać",
  "8dad6d950d": "Nie udało się uzyskać informacji o zaproszeniu",
  "a5f0ac3a9a": "Stworzone pomyślnie",
  "4f1d069770": "Parametr utm strony zaproszenia to {0} i name {1}",
  "f9578cfe6d": "Parametr utm dwustopniowego przewodnika to {0} i name {1}",
  "e10d028405": "Dwuetapowe Wprowadzenie Do Pcoffice Utworzone",
  "8e22e4fcc4": "Link zaproszenia został skopiowany",
  "3f327f9f37": "Nie udało się skopiować, spróbuj ponownie",
  "bd1aecb265": "Anuluj",
  "b6abf9b19a": "Zgadzam się",
  "e910d9cc0f": "Anuluj",
  "37ab25522d": "Zgadzam się",
  "196b3eb9cf": "Skanuj, aby dołączyć",
  "2b81c52e20": "Pobierz zdjęcie",
  "62152fd9f3": "Link zaproszenia",
  "e0a3725651": "Przepraszamy, Twoja przeglądarka nie obsługuje pobierania tego kodu QR",
  "8b7883b2c7": "Skanuj, aby dołączyć",
  "9e9a659ed5": "Pobierz zdjęcie",
  "0d55065a9a": "Link zaproszenia",
  "487cf6a106": "Przepraszamy, Twoja przeglądarka nie obsługuje pobierania tego kodu QR",
  "78fd005d1f": "Proszę wprowadzić numer telefonu",
  "f909563857": "Użyj tego numeru do utworzenia",
  "a26a19f139": "Anuluj utworzenie",
  "cc004ac9ee": "Numer telefonu",
  "4df8c3c588": "Wprowadź inny numer telefonu, aby utworzyć szkołę",
  "3151cabb3d": "Wprowadź inny numer telefonu, aby utworzyć firmę",
  "56098a71eb": "Kliknij, aby uruchomić inteligentną weryfikację, wyślij kod weryfikacyjny",
  "e96ec218e4": "Proszę wprowadzić kod weryfikacyjny SMS",
  "ce619a0225": "Kod weryfikacyjny SMS został wysłany do",
  "0e9863aaeb": "Nieprawidłowy kod, proszę wprowadzić ponownie",
  "32dc8629e1": "Sekundy do ponownego wysłania",
  "e4eda9add5": "Wyślij ponownie",
  "b007977564": "Nie udało się uzyskać informacji o zatwierdzeniu",
  "d8852ffc9c": "Dostęp bez uprawnień administratora",
  "8a733a2574": "Dostęp z urządzenia mobilnego",
  "9e8c152c4f": "Uzyskaj dostęp do wersji PC",
  "2265a55e93": "Zgadzam się na warunki usługi",
  "80dabe5aa3": "Utwórz przewodnik",
  "7deee8bf5a": "Dwuetapowe Wprowadzenie Do DocsWeb Utworzone",
  "69eb501ecb": "Twoje odwołanie wygasło, brak dostępu",
  "aa1d9d98ad": "Niewystarczające uprawnienia, brak dostępu",
  "fdf2fe129e": "Utwórz Instytucję",
  "7f0ca0df6b": "Ukryj standardowe lokalizacje",
  "cc6ac2a93c": "Dwustopniowy Przewodnik Baza zamontowana",
  "5d6c570bf0": "Dwustopniowy Przewodnik przed zakończeniem pracy",
  "a4eb8a192d": "Zespół tworzony przez wszystkich",
  "4912e16a9d": "Nazwa przedsiębiorstwa odzyskana",
  "41c4e87ef2": "Możesz kliknąć na link",
  "5e630930c0": "Ponownie utwórz Przedsiębiorstwo",
  "436a563524": "Jeśli już utworzyłeś przedsiębiorstwo, możesz się odnieść do",
  "0b6e7cbe7f": "„Jak zmienić nazwę przedsiębiorstwa”",
  "cb7bce0775": "Samouczek zmiany nazwy przedsiębiorstwa",
  "3feadd3040": "Bieżąca wersja zbyt niska, aby korzystać z przedsiębiorstwa",
  "3cf23de936": "Twoja wersja oprogramowania jest zbyt niska, funkcje przedsiębiorstwa są niedostępne. Proszę zaktualizować wersję oprogramowania w sklepie z aplikacjami!",
  "a1c5d5d202": "OK",
  "e50183bd00": "WPS Cloud",
  "e5031ab679": "Bezpieczeństwo, synchronizacja, współpraca",
  "c870026dfc": "Logowanie Wechat",
  "e7647cd875": "Logowanie za pomocą konta Wps",
  "07b380074b": "Logowanie QQ",
  "67921724dd": "Inne sposoby",
  "254da8a9f5": "Limit dołączania/tworzenia przedsiębiorstw został osiągnięty",
  "3648e4811b": "Wejdź do Dokumentów",
  "dcd102b346": "Utwórz niestandardowy zespół",
  "8b9b258cbf": "Wpisz nazwę zespołu tutaj",
  "19bb6e0ded": "Członkowie WPS",
  "2d9fe8d938": "przywileje biurowe pomagają rozwiązywać codzienne problemy dokumentacyjne, zacznij doświadczać!",
  "e8c1caa649": "Prześlij Lokalnie",
  "03641083a3": "Przenieś z „Dokumentów osobistych”",
  "eecd3ab9b5": "Kolejnym razem",
  "13b447b3a8": "Zamień",
  "3c2fc507fc": "Bieżąca wersja zbyt niska, aby korzystać z przedsiębiorstwa",
  "c3615d8134": "Twoja wersja oprogramowania jest zbyt niska, funkcje przedsiębiorstwa są niedostępne. Proszę zaktualizować wersję oprogramowania na stronie głównej!",
  "644a36e05b": "Zaktualizuj",
  "d435105f21": "Limit dołączania/tworzenia przedsiębiorstw został osiągnięty",
  "73a286ceb0": "Wejdź do Dokumentów",
  "c2cec645c0": "Anuluj",
  "b5f5b83c0f": "Zgadzam się",
  "76ec352da5": "Zeskanuj kod, aby zaprosić współpracownika",
  "6a509e4487": "Pobierz kod QR",
  "940cc4a546": "Nie można utworzyć przedsiębiorstwa",
  "78b2a62ea5": "Dołącz do istniejącego lub utwórz nowe przedsiębiorstwo",
  "3a6da7f6f9": "Bieżący numer telefonu osiągnął limit przypisanych przedsiębiorstw (maksymalnie można przypisać 5 przedsiębiorstw)",
  "93bab52870": "Bieżący numer telefonu już przypisany do przedsiębiorstwa, możesz wybrać istniejące przedsiębiorstwo do logowania:",
  "ce6e0adaf2": "Możesz wybrać, aby wejść do przypisanych przedsiębiorstw poniżej:",
  "1ce200a92b": "Zaznacz",
  "bb91ef2999": "Utwórz nowe przedsiębiorstwo",
  "024e4a91e5": "Nazwa przedsiębiorstwa jest już zarejestrowana",
  "eb089a23a0": "Ta nazwa przedsiębiorstwa jest już zarejestrowana:",
  "7646558701": "Administrator:",
  "1d9c02bd33": "Data rejestracji:",
  "919fc7805f": "Zalecamy, abyś spróbował znaleźć i skontaktować się z Twoim współpracownikiem.",
  "0ca71a9344": "Możesz również tymczasowo użyć innej nazwy do utworzenia przedsiębiorstwa (może być zmieniona później), a następnie złożyć odwołanie.",
  "e83a244e90": "Kliknij, aby dowiedzieć się, jak się odwołać.",
  "d22bedfb21": "OK",
  "907b78b6e5": "Wprowadź nazwę grupy roboczej lub zespołu",
  "7195b0ac1e": "Zespół, który możesz chcieć utworzyć",
  "60ed4f915e": "Dalej",
  "f5ba8dfb7b": "Pomiń przewodnik",
  "5c44a3ef68": "Maksymalnie 100 znaków",
  "130c53fb20": "Nazwa nie może zawierać nielegalnych znaków ani symboli specjalnych /\\;:*?\"<>|%&",
  "e832d41acc": "Dwustopniowy przewodnik Pomiń",
  "80d9cf7177": "Dwustopniowy przewodnik Odśwież",
  "0aebf80435": "Dwustopniowy przewodnik Kliknij etykietę",
  "e74f515977": "Dwustopniowe prowadzenie handleSubmit",
  "308d2a53c9": "Dwustopniowe prowadzenie createGroup",
  "dda2ed7e18": "Dwustopniowy przewodnik Niepowodzenie tworzenia zespołu",
  "ded3c35500": "Niepowodzenie tworzenia zespołu",
  "4f18031bc1": "Dwustopniowe prowadzenie createTemplate",
  "091e5cefcc": "Dwustopniowe prowadzenie createTemplate error",
  "58cf4e00f0": "Kod weryfikacyjny",
  "92abbf0385": "Wyślij kod weryfikacyjny",
  "f0f9976ef9": "Wprowadź numer telefonu",
  "a4ce99b1df": "Kod weryfikacyjny",
  "39d36e0f9f": "Potwierdź",
  "0fd8a01938": "Wyślij",
  "9048a4e842": "Numer telefonu",
  "9afa1091eb": "Wyślij ponownie",
  "58d787001f": "Wprowadź inny numer telefonu, aby utworzyć szkołę",
  "450905a265": "Wprowadź inny numer telefonu, aby utworzyć firmę",
  "f7386de3c6": "Wybierz z listy rozwijanej",
  "27aa05a92c": "Zgadzam się z regulaminem usługi",
  "80af61cb57": "Wróć do poprzedniej strony",
  "50149b8d4f": "Imię i nazwisko wnioskodawcy",
  "e6756f8749": "Proszę wprowadzić swoje imię i nazwisko",
  "3cbd51a2b1": "Imię musi mieć minimum 2 znaki, wprowadź imię o długości 2~10 znaków",
  "4f79b4813f": "Imię i nazwisko może zawierać tylko chińskie znaki, cyfry, język angielski i ·",
  "71d3e75983": "Powszechny numer telefonu",
  "afe5149035": "Proszę wprowadzić swój powszechny numer telefonu",
  "1e9270b50f": "Proszę wprowadzić swój powszechny numer telefonu, 11 cyfr",
  "ff5dc98dfb": "Pomiń",
  "165be2ab43": "Wróć do poprzedniego kroku",
  "231d8a335a": "Zgadzam się z regulaminem usługi",
  "1cad008ffc": "Nazwa firmy {0} została już zarejestrowana, proszę użyć innej nazwy",
  "c6e274fcab": "Potwierdzenie umowy",
  "b9352504bb": "Zamknij okno dialogowe umowy",
  "8409e99ad0": "Otwórz okno dialogowe umowy",
  "1593c6dd95": "Prześlij",
  "4f44a9de22": "Otwórz weryfikację SMS",
  "26b70c68b8": "Pomiń, aby przejść bezpośrednio do firmy",
  "a8bebcb302": "Wróć do poprzedniej strony",
  "c800b4fec5": "Strona zaproszenia Zamontowana Bazowa",
  "38b396d5b0": "Strona zaproszenia Zamontowane DocsWeb",
  "2eb7f9a9f1": "Twoje odwołanie zostało pomyślnie złożone",
  "2c6f3590fb": "Szacujemy, że w ciągu 3 dni roboczych wyślemy wyniki na Twój adres e-mail,",
  "2ea3eff708": "proszę monitorować swoją skrzynkę.",
  "53acfba22c": "Zaproś teraz kolegów",
  "4e6d282f4f": "Dołącz do zaproszenia do firmy",
  "5f72f4b936": "Zaproś teraz kolegów",
  "e5383077ba": "Odzyskaj nazwę firmy",
  "06e3fa2350": "Według wyszukiwania,",
  "653a263b5e": "twórcą jest",
  "769f57269f": "Numer telefonu twórcy to",
  "09a224695e": "Proszę potwierdzić, czy twórca tej firmy jest Twoim współpracownikiem",
  "3beda6c149": "Jeśli to jest twój kolega, możesz się z nim skontaktować",
  "5c74dd10d1": "Zmień nazwę firmy lub przekaż uprawnienia superadministratora.",
  "da504edb0f": "Jeśli to nie jest twój kolega, kliknij poniższy przycisk, aby kontynuować odzyskiwanie nazwy firmy.",
  "39194faaf1": "Kontynuuj odzyskiwanie nazwy firmy",
  "e22b829e90": "Skopiowano pomyślnie",
  "6e1b44752a": "Wartość TXT",
  "79881b1d7a": "Natychmiast zaproś współpracownika",
  "a5344a45f9": "Kliknij w prawym górnym rogu, wybierz 'Wyślij do znajomych'",
  "a4954a5b08": "Natychmiast zaproś współpracownika",
  "8e3a1625fb": "Odzyskaj nazwę firmy",
  "bf8b8c7005": "Prześlij licencję biznesową firmy",
  "bfd44a66c9": "Kliknij, aby wybrać",
  "d503f20925": "Prześlij skan lub zdjęcie licencji biznesowej firmy",
  "cbebe043c5": "Obsługiwane formaty JPG, JPEG, PNG, BMP, PDF, maksymalny rozmiar 10 MB.",
  "9650b96d7d": "Prześlij formularz reklamacji nazwy",
  "c3b8ae46d3": "Prześlij skan lub zdjęcie formularza reklamacji nazwy",
  "9e325a9e09": "Pobierz szablon formularza",
  "a4711aae88": "Wyślij wniosek",
  "3a5cc1441e": "W trakcie weryfikacji...",
  "0bd7bf8511": "Obecnie nie możemy zweryfikować Twojej domeny, może być konieczne poczekanie na aktualizację informacji przez dostawcę usług hostingowych domeny. Jeśli po jakimś czasie wciąż nie będzie reakcji, spróbuj ponownie zweryfikować lub zmień domenę.",
  "fae48d554b": "Sprawdzanie domeny",
  "5e1779a0ca": "rekord weryfikacji, możesz zamknąć tę stronę i wrócić później, aby sprawdzić.",
  "ca85f8b836": "Witamy w wersji biznesowej",
  "2570e0f00b": "Logowanie nie powiodło się",
  "40d16a007e": "Twoje osobiste konto zostało automatycznie powiązane",
  "81376b92e4": "metoda logowania {0}, zaloguj się ponownie, aby przełączyć konto firmowe.",
  "ba679ba739": "Rozumiem, zaloguj się",
  "c05f64c6c6": "Po {0} automatycznie przejdź do logowania",
  "c329ccef3a": "Logowanie nie powiodło się",
  "e370f9afb1": "Twoje osobiste konto zostało automatycznie powiązane",
  "410cf42585": "metoda logowania, zaloguj się ponownie, aby przełączyć konto firmowe.",
  "062d48aece": "Rozumiem, zaloguj się",
  "95a105d412": "Po automatycznym skierowaniu do logowania",
  "2d000d5a6d": "Wyślij link do udostępnienia członkom, członkowie po otwarciu mogą ubiegać się o dołączenie",
  "8861b6e90d": "Wejdź do firmy",
  "25b9f72fda": "Błąd parametrów strony",
  "1c76123efc": "Nie udało się uzyskać linku zaproszenia",
  "6caba48b76": "Pomiń",
  "f66379c650": "Błąd parametrów strony",
  "c45021de2a": "Nie udało się utworzyć.",
  "011d470126": "Platforma nadal chroni Twoje dane",
  "f1a44d9151": "Platforma uzyskała certyfikaty ISO27001 i ISO27701 wydane przez BSI oraz przeszła ocenę bezpieczeństwa poziomu III wydaną przez krajowy organ ds. ochrony bezpieczeństwa --",
  "255ea5dff7": "Biała księga bezpieczeństwa",
  "bb55b124f2": "Utwórz Prezentację Firmową",
  "61e24974a3": "Utwórz Strategię Uzyskiwania Treści Firmowych",
  "bfdf78febe": "Następny Krok: Uzupełnij Informacje",
  "c4aa2d2d60": "Wprowadź Nazwę Zespołu Roboczego lub Projektu",
  "b69765ab64": "Zespół, który Wszyscy Tworzą",
  "9657d9408b": "Zamień",
  "e21da8c16a": "Dalej",
  "224ef5cc9f": "Pomiń Przewodnik",
  "641f58c8f6": "Obecna Firma Nie Wspiera Tworzenia Zespołów przez Członków, Proszę Skontaktować się z Administratorem",
  "efea622752": "Skopiuj Link, Zaproś Współpracowników",
  "fd5b40a9fd": "Zaprasza Cię Dołączenia do „{0}”, Współpracujmy razem",
  "b04dd2f10a": "Link Zaproszenia Skopiowany",
  "d1606a1b1a": "Błąd Kopiowania, Proszę Spróbować Ponownie",
  "0d59f3db83": "Wpisz dział projektu lub zespołu, np. „Dział Sprzedaży”",
  "9429513d34": "Nie Potrzebuję Przewodnika",
  "b54a20b1ff": "Nie udało się utworzyć.",
  "093fa0fb74": "Trwa Autoryzacja Logowania...",
  "b383b136f4": "Inicjalizacja Projektu Firmowego",
  "b6b21b388b": "Nazwa Firmy Została Już Zarejestrowana",
  "285dc68c10": "Nazwa Firmy Została Już Zarejestrowana:",
  "1bf685b89d": "Administrator:",
  "7b4297edcc": "Data Rejestracji:",
  "fa51ea19fc": "Sugerujemy, aby spróbować znaleźć i skontaktować się z powyższym współpracownikiem.",
  "e3678a996d": "Możesz również tymczasowo użyć innej nazwy, aby utworzyć firmę (później można to zmienić) i złożyć odwołanie.",
  "5969bc8071": "W porządku",
  "ba4cf699df": "Odzyskaj Nazwę Firmy",
  "afecee4eb4": "Twoje Imię",
  "a8bdebc614": "Proszę Wprowadzić Swoje Imię",
  "5bbeb38a66": "Numer telefonu",
  "b4f7b44b7a": "Proszę Wprowadzić Swój Numer Kontaktowy",
  "cac2913686": "Email Kontaktowy",
  "23d3bb3a42": "Proszę Wprowadzić Swój Email Kontaktowy",
  "ea106a393c": "Załaduj Licencję Handlową Firmy",
  "f74131d71e": "Kliknij, aby Wybrać",
  "53749c51c5": "Proszę Załaduj Skany lub Zdjęcia Licencji Handlowej Firmy",
  "c00f2ea171": "Obsługiwane formaty: JPG, JPEG, PNG, BMP, PDF, maksymalny rozmiar 10 MB.",
  "57ec07fa97": "Załaduj Formularz Odwołania o Duplikat Nazwy",
  "8eb0606e94": "Proszę Załaduj Skany lub Zdjęcia Formularza Odwołania o Duplikat Nazwy",
  "f59e76c0b0": "Pobierz Szablon Formularza Informacyjnego",
  "030bd26fa4": "Prześlij Wniosek",
  "0a602dc727": "Bezpieczne Przechowywanie Danych",
  "9138f28acf": "Współdzielona Praca na Dokumentach",
  "b3a306cf90": "Zgodność i Prawidłowość Licencji",
  "973c53f725": "Zalecana Zmiana Nazwy; Po Rejestracji Możliwe Złożenie Certyfikacji Instytucji i Aktualizacja Nazwy",
  "f886f5e92f": "Zalecana Zmiana Nazwy; Po Rejestracji Możliwe Złożenie Certyfikacji Firmy i Aktualizacja Nazwy",
  "b8051702a3": "Nazwa Zawiera Słowa Wrażliwe; Proszę Dostosować Nazwę lub Skontaktować się z Obsługą Klienta",
  "d73881f7d4": "Nazwa Firmy jest Chroniona",
  "dc7e58e320": "Nazwa Firmy Jest Chroniona; Przed Użyciem Należy Zweryfikować Informacje o Podmiocie. Zalecana Zmiana Nazwy Firmy lub Zarejestrowanie Przez Certyfikację Firmową Przed Użyciem Nazwy.",
  "20c3bc070c": "Potwierdź",
  "c4278e5f28": "Brak uprawnień",
  "9217efae21": "Twoje konto nie ma uprawnień do tworzenia, skontaktuj się z działem sprzedaży",
  "52ff08f2ad": "Nazwa instytucji jest chroniona, proszę zmienić nazwę przedsiębiorstwa",
  "79386ae280": "Proszę wprowadzić 6-cyfrowy kod weryfikacyjny",
  "d7b2c5a41b": "Kod weryfikacyjny został wysłany do",
  "ce2e1c26f7": "(ważny przez 10 minut)",
  "59d338903f": "Można ponownie uzyskać kod weryfikacyjny po upływie {0} sekund",
  "5aadd14136": "Uzyskaj kod weryfikacyjny ponownie",
  "90f5c93432": "Ta nazwa została już zarejestrowana",
  "1677072f4a": "Możesz podać więcej informacji lub zarejestrować się pod inną nazwą",
  "3b8459fb1e": "Szybkie wprowadzenie:",
  "6f38edbcb1": "Zarejestruj się pod tą nazwą",
  "8406c81e2d": "Oddział",
  "29d323fa85": "Filia",
  "4f0e806e02": "Dział finansowy",
  "3f935efb6b": "Zgoda na umowę o świadczenie usług",
  "b42241be05": "Nie teraz",
  "99de4b33b7": "Zgadzam się",
  "7f867e7395": "Utwórz przedsiębiorstwo używając innego numeru telefonu",
  "0d51a8f7a6": "Kontynuuj tworzenie",
  "8bdaecf2e5": "Proszę podać numer telefonu",
  "565ae60c8a": "Proszę podać swoje imię i nazwisko",
  "f76e06d0e7": "Proszę podać numer telefonu",
  "7b0fca5255": "Proszę podać kod weryfikacyjny",
  "68026d2d25": "Witamy w wersji dla przedsiębiorstw",
  "d25b5541be": "Utwórz za darmo",
  "32cfd73733": "Proszę wprowadzić nazwę zespołu, przedsiębiorstwa lub organizacji",
  "4cf83dc4a0": "Szybkie tworzenie w minutę, efektywna współpraca z kolegami",
  "d320d37116": "Utwórz darmowy zespół/przedsiębiorstwo",
  "c54b475dd2": "Umowa użytkownika",
  "190d54e616": "Przedsiębiorstwo {0}",
  "8c1b768ac4": "Nieudana weryfikacja inteligentna",
  "d74eab0f35": "Wpisane dane dotyczące nazwy przedsiębiorstwa nie są zgodne z normami platformy, proszę spróbować ponownie po ich poprawieniu",
  "0f3d62dd4f": "Wpisane dane dotyczące imienia i nazwiska nie są zgodne z normami platformy, proszę spróbować ponownie po ich poprawieniu",
  "647cf2211b": "Obecny numer telefonu nie jest obsługiwany do tworzenia, proszę użyć innego",
  "b63d96cdae": "Wpisane informacje nie są zgodne z normami platformy, proszę spróbować ponownie po ich poprawieniu",
  "2dbbe8e43f": "Obecny numer telefonu nie jest obsługiwany do tworzenia, proszę użyć innego",
  "b18abc5de6": "Brak powiązanego numeru telefonu",
  "f5233dae6f": "Proszę użyć innego numeru telefonu do utworzenia",
  "4167c8b88d": "Obecny numer telefonu może mieć następujące problemy, proszę spróbować użyć innego numeru telefonu do utworzenia. W razie pytań, skontaktuj się z obsługą klienta.",
  "a8a2433c4d": "Zeskanuj kod QR w WeChat aby dodać, skontaktuj się z obsługą klienta",
  "444a639c09": "Rozumiem",
  "69a097057f": "Ten numer telefonu należy do <#BB2726>segmentu operatora wirtualnego<#BB2726>",
  "4370b06fd0": "Aktualny numer telefonu wykazuje <#BB2726>nietypowe zachowania użytkowe<#BB2726>",
  "8c49e1dc4a": "Wymagana weryfikacja CAPTCHA",
  "4b8ba7d8cc": "Nowa platforma produktywności biurowej",
  "81be771e17": "🎉Pomyślnie utworzono firmę! Uzupełnij informacje, aby uzyskać dedykowane usługi.",
  "461125b057": "Możesz zarządzać dokumentami i materiałami w zespole. Członkowie zespołu mogą łatwo przeglądać informacje oraz ustawiać uprawnienia do edytowania/pobierania w celu zapewnienia bezpieczeństwa danych",
  "c3eb25029b": "Rozmiar firmy/zespołu",
  "049f8401ec": "Poniżej 5 osób",
  "c81896349e": "6-20 osób",
  "7357daac4e": "21-50 osób",
  "f0e65a0a29": "51-100 osób",
  "b9fac8204a": "101-200 osób",
  "62d73dddaf": "201-500 osób",
  "3bcdaf7160": "501-2000 osób",
  "ab0b2333fe": "Powyżej 2000 osób",
  "4f756eedc8": "Twoja rola to",
  "3ba0b502c3": "Ogólny dyrektor",
  "702099cc72": "Finansowe",
  "843b603162": "Zakupy",
  "8b414a9b44": "HR/Administracja",
  "92486b2908": "Sprzedaż",
  "ac4e7fb063": "Czy organizacja ma budżet na oprogramowanie biurowe/plan zakupu",
  "37634c72dc": "W ciągu pół roku",
  "bd94b6deec": "W ciągu roku",
  "713f4aad5c": "Rozważa",
  "c5ea095a4d": "Brak planów",
  "2409099a69": "<img src=\"https://ks3-wpsplus-prod.wpscdn.cn/e2546275-3953-40b4-8933-9ff6f0a1aeb4.png\"> Utwórz zespół i zaproś członków do wspólnej pracy.",
  "9d27dc2d90": "Wprowadź nazwę swojego zespołu lub projektu, którym się ostatnio interesujesz",
  "de19c8509a": "Możesz utworzyć:",
  "1a84699223": "Dział sprzedaży",
  "efab59502b": "Dział produktów",
  "7e599b3713": "Południowy dział operacyjny",
  "bf494779c2": "Dział zakupów",
  "f3a60ab34d": "Dział administracyjny",
  "bbc50c1ac8": "Północny dział finansowy",
  "32629e3dac": "Dział finansowy produktów",
  "5524d354ba": "Dział IT",
  "0ccda29a0d": "🎁<span style='color: rgb(206,131,62);'>Odkryto korzyści dla początkujących!</span> Zaproś jeszcze 3 osoby, aby otrzymać <span style='color: rgb(206,131,62);'>4T przestrzeni, WPS AI</span>.",
  "939eb98492": "<span style='color: rgb(206,131,62);'>Odblokowano limit 50 osób i maksymalny rozmiar 4G dla pojedynczego pliku.</span> Kontynuuj zapraszanie 3 osób, aby odblokować 30-dniowe WPS AI oraz 4T przestrzeni z dodatkowymi korzyściami.",
  "136c26d941": "Skopiuj poniższy link, aby zaprosić członków do dołączenia",
  "3de5c12558": "Skopiuj link, aby zaprosić kolegów",
  "a5d64b14f3": "Przewodnik informacji o firmie",
  "b8f2492701": "Zbieranie informacji o firmie",
  "1f9d053dc0": "Utwórz szablon zespołu",
  "0e83c79a88": "Zaproś użytkowników",
  "821fc1906a": "Wejdź do firmy",
  "463e14ae9c": "Proszę wybrać zespół",
  "690f0cdb9e": "Ukończ ikonę",
  "c340522a17": "Wstecz",
  "f9355c72ef": "Pomiń",
  "bd6c09ebbb": "Dalej",
  "2a2603cd3f": "Zeskanuj i wyślij zaproszenie do kolegów",
  "411e64907a": "Kopiuj",
  "b0d988cf23": "Pobierz",
  "e3c0b650ac": "Skopiowano pomyślnie",
  "713ac624b4": "Witamy w WPS 365",
  "b8fff97849": "Nieprawidłowy element docelowy",
  "02acdcf296": "html2canvas nie powiodło się konwersja, nie wygenerowano canvas",
  "a76988c496": "Konwersja canvas do blob nie powiodła się",
  "af89584edf": "API schowka niedostępne",
  "f90263bbde": "Kopiowanie obrazu nie powiodło się",
  "71b05319da": "html do canvas nie powiodło się",
  "38852999fe": "Zapisywanie informacji nie powiodło się",
  "4a4c621d07": "Utworzenie zespołu nie powiodło się, spróbuj ponownie później",
  "d239a23994": "Obecna strona dostępna jest tylko dla konta firmowego, zaloguj się najpierw na konto firmowe.",
  "d93bfb7fb9": "Proszę wprowadzić treść",
  "42b81a66c4": "Długość od 2 do 100 znaków",
  "76d33733db": "Nie może zawierać / \\ ; : * ? \" < > | % & itp. znaków specjalnych",
  "dc55d1f62f": "Przejdź do wypróbowania",
  "b25233cba0": "Dokumenty współpracy + komunikacja w czasie rzeczywistym, otwórz nowy sposób efektywnej pracy.",
  "f0e563652d": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Rozpocznij czat grupowy do współpracy, udostępnianie dokumentów jest bezpieczne i wygodne.",
  "1e484cce68": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/lingxi_normal.png\"> Asystent AI Lingxi, inteligentny asystent stworzony z myślą o pracy biurowej.",
  "e338385bc9": "Inteligentne biuro Office natywnie, głęboka integracja AI z oprogramowaniem biurowym, aby każdy miał asystenta AI",
  "7ae1f3b1c6": "Import plików (folderów) zakończony, możesz sprawdzić wyniki importu w 'Moje dokumenty w chmurze'",
  "85db2a024a": "Import plików (folderów) nie powiódł się, spróbuj ponownie później",
  "9ff74c802a": "Pobierz wersję dla procesorów Intel",
  "ab44928f02": "Pobierz wersję dla procesorów Apple",
  "a08d937c38": "Przesyłanie plików (folderów) w toku, po zakończeniu możesz je sprawdzić w 'Moje dokumenty w chmurze'",
  "68db1829fa": "Import obsługiwany wyłącznie z konta osobistego, zaloguj się na konto osobiste i spróbuj ponownie.",
  "1185a7c7ab": "Mniej niż 20 osób",
  "e2bcc252c9": "21-300 osób",
  "3c4842f1ea": "301-1000 osób",
  "1bbee64cfa": "Powyżej 1000 osób",
  "388ff4a035": "Nauczyciel",
  "d341b1d794": "Uczeń",
  "bfb2ee4148": "Więcej",
  "f6450c3f31": "Zarządzanie projektami",
  "b87fd33a0d": "Plan roczny",
  "0dd45a1c14": "Zarządzanie efektywnością pracowników",
  "67fa01cac6": "Działania marketingowe",
  "6dd82cc031": "Rekrutacja pracowników",
  "a7edaed91d": "Materiał dydaktyczny",
  "bf12b7efb0": "Zarządzanie planem nauczania",
  "c35ae8f358": "Dokumentacja produktu",
  "343f236a78": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/dbsheet.png\"> WPS Wielowymiarowa tabela, wizualizuj budowanie własnego systemu biznesowego",
  "72286d5519": "👏Polecany szablon",
  "0bc00ee949": "Zarządzanie defektami wymagań",
  "e22f3d56f7": "Zarządzanie tworzeniem treści",
  "dd439de3dd": "System zarządzania klientami",
  "fbb2bbf82e": "Plan przygotowań",
  "0645b908bc": "Wyszukiwanie wynagrodzeń",
  "813b3d3d7e": "Zarządzanie OKR",
  "918e33d5bd": "Stwórz jednym kliknięciem",
  "ebf9cfb7ef": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/import_files.png\"> Importuj często używane dokumenty, używaj bardziej wygodnie",
  "c58f28713c": "Importuj lokalnie",
  "9d6a0a4370": "Obsługa powszechnych formatów plików Office",
  "54c48aee85": "Wybierz plik",
  "c5b593e452": "Importuj z konta osobistego",
  "4bdcd9d4c5": "Importuj dokumenty osobiste, zespoły i foldery jednym kliknięciem",
  "99b2968905": "Autoryzacja importu",
  "472f818a23": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Pobierz klienta WPS Teams",
  "fe46574227": "Współpraca nad dokumentami + komunikacja natychmiastowa, nowy sposób efektywnej pracy",
  "beefe5a09b": "Pobierz teraz",
  "278839c7b1": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Bogate ustawienia zabezpieczeń, zapewniające bezpieczeństwo danych",
  "b4e70dbeab": "Wieluletnie doświadczenie WPS w zakresie bezpieczeństwa dokumentów zapewnia, że kluczowe dane firmowe nie będą wyciekać",
  "42dc772619": "Plik jest zbyt duży, zaleca się ponowny import na stronie głównej później",
  "a052564e47": "Błąd podczas tworzenia, spróbuj ponownie później",
  "790d0c428c": "Wejdź do pulpitu"
}